export enum PrivateLocalStorageKey {
	CLIENT_MODEL_COLLECTION = 'clientModelCollection',
	SELECTED_CLIENT_MODEL = 'selectedClientModel',
	SELECTED_FACILITY_MODEL = 'selectedFacilityModel',
	REPORT_JSON_WEB_TOKEN = 'reportJsonWebToken',
	WASTE_MANAGEMENT_REPORT_JSON_WEB_TOKEN = 'wasteManagementReportJsonWebToken'
}
